import { Box, Skeleton } from "@mui/material";
import { initializeApp } from "firebase/app";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import { getDatabase, onValue, ref, remove } from "firebase/database";
import Carousel from "react-material-ui-carousel";
import VideoElmBuffering from "../common/VideoElmBuffering";

export const GET_WIDGET_ELEMENT = (
  mediaType = "single_image",
  status = "completed",
  imageData,
  thumbnail
) => {
  if (mediaType === "carousel" && status === "completed") {
    return (
      <>
        <Carousel autoPlay={false} navButtonsAlwaysVisible>
          {imageData.map((el) => (
            <>
              <img className="skeleton-loading" src={el} alt="Post Image" />
            </>
          ))}
        </Carousel>
      </>
    );
  }
  if (mediaType === "single_image" && status === "completed") {
    return (
      <>
        <img src={imageData[0]} alt="Post Image" />
      </>
    );
  }
  if (mediaType === "single_image" && status === "inProgress") {
    return (
      <Box>
        <Skeleton height={300} animation={"wave"} />
      </Box>
    );
  }
  if (mediaType === "carousel" && status === "inProgress") {
    return (
      <Box>
        <Skeleton height={300} animation={"wave"} />
      </Box>
    );
  }
  if (mediaType === "video" && status === "error") {
    return (
      <>
        <img className="skeleton-loading" src={imageData[0]} alt="Post Image" />
      </>
    );
  }
  if (mediaType === "video" && status === "inProgress") {
    return (
      <Box>
        <Skeleton height={300} animation={"wave"} />
      </Box>
    );
  }
  if (mediaType === "video" && status === "completed") {
    return (
      <>
        <video
          src={imageData[0]}
          poster={thumbnail}
          controls
          controlsList="nodownload"
          style={{ height: "300px", margin: "auto" }}
        ></video>
        {/* <VideoElmBuffering videoSource={imageData[0]} posterUrl={thumbnail} /> */}
      </>
    );
  }
};

const FIREBASE_CONFIG = {
  apiKey: "AIzaSyAzX-jeeVITX7BFDWyjxmqNGT-SU0zLwyg",
  authDomain: "fiery-nimbus-261705.firebaseapp.com",
  databaseURL: "https://fiery-nimbus-261705-default-rtdb.firebaseio.com",
  projectId: "fiery-nimbus-261705",
  storageBucket: "fiery-nimbus-261705.appspot.com",
  messagingSenderId: "295142708",
  appId: "1:295142708:web:a2303b0f515d04fdb35161",
  measurementId: "G-4ESYT0F1HQ",
};

export const WIDGET_FIRE_LISTEN = (customToken, fireUid, fireJobId, event_id, callback) => {
  const fireApp = initializeApp(FIREBASE_CONFIG);
  const fireAuth = getAuth(fireApp);
  signInWithCustomToken(fireAuth, customToken).then((userCredentials) => {
    // console.log("user Credentials", userCredentials);
    const database = getDatabase(fireApp);
    const Ref = ref(database, "content_library/" + `${fireUid}/` + `${fireJobId}/` + `${event_id}`);
    // console.log("ref", "content_library/" + `${fireUid}/` + `${fireJobId}/` + `${event_id}`);
    onValue(Ref, (snapshot) => {
      const data = snapshot.val();
      // console.log("data", data);
      if (data.status === "completed") {
        if (data.media_type === "video") {
          callback(
            data.media_type,
            data.status,
            data.caption,
            data.creative_details[0].url,
            data.creative_details[0].thumb_url
          );
        } else if (data.media_type === "carousel") {
          callback(
            data.media_type,
            data.status,
            data.caption,
            data.creative_details[0],
            data.creative_details[0].thumb_url
          );
        } else {
          callback(data.media_type, data.status, data.caption, data.creative_details[0].url);
        }
        remove(Ref).then((res) => {
          console.log("Deleted");
        });
      } else {
        callback(data.media_type, data.status);
      }
    });
  });
};
